var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabShipperIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.459,
    height: 9.717,
    viewBox: "0 0 45.459 9.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12524",
    "data-name": "Group 12524",
    transform: "translate(1211.486 -325.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12522",
    "data-name": "Group 12522",
    transform: "translate(-2478 -417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39711",
    "data-name": "Path 39711",
    d: "M1308.406,752.056h-29.542l3.109-9.062h29.542Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_604",
    "data-name": "Line 604",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1282.343 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_605",
    "data-name": "Line 605",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1287.078 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_606",
    "data-name": "Line 606",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1291.814 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_607",
    "data-name": "Line 607",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1296.549 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_608",
    "data-name": "Line 608",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1301.285 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_609",
    "data-name": "Line 609",
    x1: 2.021,
    y2: 5.891,
    transform: "translate(1306.021 744.571)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_610",
    "data-name": "Line 610",
    x1: 10.068,
    transform: "translate(1269.623 742.994)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_611",
    "data-name": "Line 611",
    x1: 10.068,
    transform: "translate(1268.586 746.015)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_612",
    "data-name": "Line 612",
    x1: 10.068,
    transform: "translate(1267.55 749.036)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_613",
    "data-name": "Line 613",
    x1: 10.068,
    transform: "translate(1266.514 752.056)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabShipperIcon);
export default __webpack_public_path__ + "static/media/tab-shipper-icon.a7b8afb77fdbe55556d5358396a5efcf.svg";
export { ForwardRef as ReactComponent };